import { connect } from 'react-redux';
import NewTarget from './newTarget'
import * as AC from '../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
        isLoading: state.targetgroup.isLoading || state.city.isLoading,
        isSaving: state.request.isSaving,
        error: state.request.error,
        checkedLicense: state.request.checkedLicense,
        message: state.request.message,
        visitorTerritory: state.profile.visitorTerritory,
        targetgroups: generateTargetgroupList(state.targetgroup.targetgroups),
        cities: state.city.cities.map( (c, index) => ({ key: index, value: c.city, text: c.city })),
        address: state.address.addresses.map( (c, index) => ({ key: index, value: c.address, text: c.address, hco: c.hco })),
        cityZipData: state.city.cityZipData
}};

function mapDispatchToProps(dispatch) {
    return({
        fetchTargetgroups: () => { dispatch(AC.TargetGroupListLoadingStarted()) },
        fetchCities: () => { dispatch(AC.CityListLoadingStarted()) }, 
        fetchAddress: (city) => { dispatch(AC.AddressListLoadingStarted(city, '', '', '', '')) },
        requestCheckLicense: (license) => { dispatch(AC.RequestCheckLicenseStarted(license) ) },
        requestAddNewTarget: (visitorTerritory, stamp, name, segmentation, mypreferredspecialtyen, mypreferredspecialtyhu, city, postalCode, address, hco ) => { dispatch(AC.RequestAddNewTargetStarted(visitorTerritory, stamp, name, segmentation, mypreferredspecialtyen, mypreferredspecialtyhu, city, postalCode, address, hco ) ) },
        clearRequestUi: () => { dispatch(AC.ClearRequestUi()) }
    })
}

function generateTargetgroupList(targetgroups) {
    return targetgroups.map( tg => ({ key: tg.myPreferredSpecialty, text: tg.myPreferredSpecialtyHu, value: tg.myPreferredSpecialty  }));
}

export default connect(mapStateToProps, mapDispatchToProps)(NewTarget);